import styled from 'styled-components';
import { mb } from 'styled-components-spacing';

export const Wrapper = styled.div`
  ${mb(24)};

  display: flex;
  align-items: center;
  justify-content: space-between;
`;